<template>
  <div class="app">
    <div class="title">
      <div class="dis">
        <div class="title_text">账号管理</div>
      </div>
    </div>
    <el-button class="Add_btn dis_center" type="primary" @click="add_btn(0)">
      <div class="dis_center">
        <img class="img11" src="../../assets/12.png" alt="" />
        <div>新增</div>
      </div>
    </el-button>
    <div class="table_pad">
      <!-- <div class="dis">
              <el-button
                class="Add_btn dis_center"
                type="primary"
                @click="add_btn(0)"
              >
                <div class="dis_center">
                  <img class="img11" src="../../assets/12.png" alt="" />
                  <div>新增</div>
                </div>
              </el-button>
            </div> -->
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
          @selection-change="handleSelectionChange" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="105">
          </el-table-column>
          <el-table-column prop="realName" label="用户名" min-width="10%">
          </el-table-column>
          <el-table-column prop="userName" label="账号" min-width="10%">
          </el-table-column>
          <el-table-column prop="password" label="密码" min-width="10%">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="14%">
          </el-table-column>
          <el-table-column prop="address" label="操作" min-width="15%">
            <template slot-scope="scope">
              <div class="dis_center table_btn">
                <div class="dis" @click="add_btn(1, scope.row)">
                  <img src="../../assets/17.png" class="img17" alt="" />
                  <div>修改</div>
                </div>
                <div class="dis table_delete" @click="delete_btn(0, scope.row.id)" v-if="scope.row.userName != 'admin'">
                  <img src="../../assets/18.png" class="img17" alt="" />
                  <div>删除</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_box">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="pageNumber" :total="total">
        </el-pagination>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_shardow">
      <div class="show_box">
        <div class="show_title dis_center">
          <div v-if="show_type == 0">新增</div>
          <div v-else>修改</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="show_detail" style="height: 220rem;">
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>用户名：</div>
            <el-input class="shardow_ipt" v-model="info.realName" placeholder="请输入用户名"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>账号：</div>
            <el-input class="shardow_ipt" v-model="info.userName" placeholder="请输入账号"
              :disabled="show_type == 1"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>密码：</div>
            <el-input class="shardow_ipt" v-model="info.password" placeholder="请输入密码"></el-input>
          </div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <button class="shardow_btn2 dis_center" @click="save" :disabled="disabled_save">
            确定
          </button>
        </div>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_delete">
      <div class="show_box">
        <div class="show_title dis_between">
          <div>删除确认</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="dis_center shardow_deleteInfo">
          <img src="../../assets/20.png" class="img20" alt="" />
          <div>确定要删除所选择的账号吗？</div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <div class="shardow_btn2 dis_center" @click="remove">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAccountMePage,
  editAccount, addAccount,
  removeAccount,
} from "../js/api";
export default {
  data() {
    return {
      disabled_save: false,
      userInfo: {},
      info: {
        realName: "",
        userName: "",
        password: "",
        userPhone: '',
        userType: '',
        userTypeId: "",
        nickName: ''
      },
      multipleSelection: [],
      chooseId: "",
      show_type: 0,
      show_shardow: false,
      show_delete: false,
      delete_type: 0,
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      input: "",
      value1: "",
      value2: "",
      value3: "",
      tableData: [],
      options1: [{
        label: '管理员',
        value: 1,
      }, {
        label: '学校账号',
        value: 2,
      }, {
        label: '老师账号',
        value: 3,
      }],
      schoolList: [],
      multipleSelection: [],
      // 级联选择器相关数据
      teacherCascaderValue: [],
      teacherCascaderOptions: [],
      teacherCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'teachers',
        emitPath: false,
        lazy: true,
        lazyLoad: this.loadTeachers
      },
      options2: []
    };
  },
  computed: {
    // 根据用户类型过滤账号类型选项
    filteredOptions1() {
      let that = this;
      if (that.userInfo.userType == 2) {
        // 学校用户只能创建学校和老师账号
        return that.options1.filter(item => item.value == 2 || item.value == 3);
      }
      // 管理员可以创建所有类型
      return that.options1;
    }
  },
  created() {
    let that = this;
    that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    that.ajaxload();
    // that.get_list();
    // that.get_SchoolList()
  },
  methods: {
    schoolChange(e) {
      let that = this;
      console.log(e)
      let obj = that.schoolList.find(item => item.id == e)
      that.info.nickName = obj.name;
    },
    // 弹窗类型变化
    onModalTypeChange() {
      let that = this;
      that.info.userTypeId = "";
      that.teacherCascaderValue = [];
      if (that.info.userType == 3) {
        that.initTeacherCascaderOptions();
      }
    },
    // 初始化级联选择器选项（只加载学校列表）
    initTeacherCascaderOptions() {
      let that = this;
      that.teacherCascaderOptions = that.schoolList.map(school => ({
        id: school.id,
        name: school.name,
        leaf: false // 表示有子节点
      }));
    },
    // 懒加载老师列表
    loadTeachers(node, resolve) {
      const { level, value } = node;

      if (level === 0) {
        // 第一级，返回学校列表
        const schools = this.schoolList.map(school => ({
          id: school.id,
          name: school.name,
          leaf: false
        }));
        resolve(schools);
      } else if (level === 1) {
        // 第二级，根据学校ID获取老师列表
        this.getTeachersBySchool(value).then(teachers => {
          const teacherOptions = teachers.map(teacher => ({
            id: teacher.id,
            name: teacher.teacherName || teacher.name,
            leaf: true // 老师是叶子节点
          }));
          resolve(teacherOptions);
        }).catch(() => {
          resolve([]);
        });
      }
    },
    // 根据学校ID获取老师列表
    getTeachersBySchool(schoolId) {
      let that = this;
      return new Promise((resolve) => {
        // 如果当前用户是学校类型，只能查询自己学校的老师
        let targetSchoolId = schoolId;
        if (that.userInfo.userType == 2) {
          targetSchoolId = that.userInfo.userTypeId;
        }

        let json = {
          entityParam: {
            schoolId: targetSchoolId
          }

        };
        getTeacherList(json).then((res) => {
          if (res.code == 200) {
            that.options2 = res.data
            console.log('that.options2', that.options2)
            resolve(res.data || []);
          } else {
            resolve([]);
          }
        }).catch(() => {
          resolve([]);
        });
      });
    },
    // 级联选择器变化事件
    onTeacherCascaderChange(value) {
      console.log(value)
      let that = this;
      if (value) {
        const teacherId = value; // 老师ID

        // 设置老师ID
        that.info.userTypeId = teacherId;

        // 获取老师信息设置nickName
        console.log('that.options2', that.options2)
        // that.getTeachersBySchool(schoolId).then(teachers => {
        const teacher = that.options2.find(t => t.id == teacherId);
        if (teacher) {
          that.info.nickName = teacher.name;
        }
        // });
      } else {
        that.info.userTypeId = "";
        that.info.nickName = "";
        that.info.schoolId = "";
        that.info.schoolName = "";
      }
    },

    // 获取学校列表
    get_SchoolList() {
      let that = this;
      // 如果当前用户是学校类型，只显示自己
      if (that.userInfo.userType == 2) {
        that.schoolList = [{
          id: that.userInfo.userTypeId,
          name: that.userInfo.nickName || that.userInfo.realName
        }];
        return;
      }

      let json = {

      }
      getSchoolList({ params: json }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          let data = res.data;
          for (let i in data) {
            data[i].id = Number(data[i].id)
          }
          that.schoolList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    select_change(e) {
      let that = this;
      let options1 = that.options1;
      for (let i in options1) {
        if (options1[i].id == e) {
          that.info.companyName = options1[i].companyName;
        }
      }
      console.log(e);
    },
    get_list() {
      let that = this;
      let json = {};
      CompanygetList(json).then((res) => {
        console.log(res);
        let data = res.data;
        for (let i in data) {
          data[i].id = Number(data[i].id);
        }
        that.options1 = data;
      });
    },
    switch_change(e, w) {
      let that = this;
      // console.log(e, w);
      that.info = JSON.parse(JSON.stringify(e));
      that.save();
    },
    rold() {
      let that = this;
      that.pageNumber = 1;
      that.ajaxload();
    },
    ajaxload() {
      let that = this;
      let json = {};
      json.pageReq = {
        pageNumber: that.pageNumber,
        pageSize: that.pageSize,
      };
      json.entityParam = {
        // companyId: that.userInfo.companyId,
        // status: that.value3,
      };
      // 当用户类型为学校时，添加userTypeId过滤条件
      if (that.userInfo.userType == 2) {
        json.entityParam.userTypeId = that.userInfo.userTypeId;
      }
      if (that.value1 || that.value2) {
        json.keyWords = {};
      }
      if (that.value1) {
        json.keyWords.nickName = that.value1;
      }
      if (that.value2) {
        json.keyWords.userPhone = that.value2;
      }
      getAccountMePage(json).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          let data = res.data.records;
          for (let i in data) {
            if (data[i].status == 0) {
              data[i].switch_type = true;
            } else {
              data[i].switch_type = false;
            }
          }
          that.tableData = data;
          that.total = Number(res.data.total);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    save() {
      let that = this;
      that.disabled_save = true;
      let json = that.info;
      if (!json.userName || !json.password || !json.realName) {
        this.$message({
          message: "请完善账号信息",
          type: "warning",
          duration: 1000,
        });
        that.disabled_save = false;
        return;
      }

      console.log(json)
      editAccount(json).then((res) => {
        that.disabled_save = false;
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "保存成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    remove() {
      let that = this;
      let json = {};
      json.id = that.chooseId;
      removeAccount({ params: json }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
          that.close();
          that.ajaxload();
        }
      });
    },
    delete_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.chooseId = w;
      } else if (e == 1) {
        if (that.multipleSelection.length == 0) {
          this.$message({
            message: "请选择用户",
            type: "warning",
          });
          return;
        }
      }
      that.delete_type = e;
      that.show_delete = true;
    },
    remove_list() {
      let that = this;

      let json = [];
      for (let i in that.multipleSelection) {
        json.push(that.multipleSelection[i].id);
      }
      userremoves(json).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
          that.close();
          that.ajaxload();
        }
      });
    },
    show_more2(e) {
      let that = this;
      if (that.multipleSelection.length == 0) {
        this.$message({
          message: "请选择用户",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      let json = [];
      for (let i in that.multipleSelection) {
        let obj = {
          id: that.multipleSelection[i].id,
          status: e,
        };
        json.push(obj);
      }

    },
    add_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.info = {
          realName: "",
          userName: "",
          password: "",
          userPhone: '',
          userType: '',
          userTypeId: "", nickName: ''
        };
        that.teacherCascaderValue = [];
      } else {
        that.info = JSON.parse(JSON.stringify(w));
        // 如果是老师账号类型，需要设置级联选择器的值
        if (that.info.userType == 3 && that.info.userTypeId) {
          that.setTeacherCascaderValue(that.info.userTypeId);
        } else {
          that.teacherCascaderValue = [];
        }
      }
      that.show_type = e;
      that.show_shardow = true;
      // 如果是老师账号类型，初始化级联选择器选项
      if (that.info.userType == 3) {
        that.initTeacherCascaderOptions();
      }
    },
    // 设置级联选择器的值（编辑时使用）
    setTeacherCascaderValue(teacherId) {
      let that = this;
      // 先根据teacherId获取老师信息，找到对应的学校
      let promises = that.schoolList.map(school => {
        return that.getTeachersBySchool(school.id).then(teachers => {
          const teacher = teachers.find(t => t.id == teacherId);
          if (teacher) {
            return school.id;
          }
          return null;
        });
      });

      Promise.all(promises).then(results => {
        const foundSchoolId = results.find(schoolId => schoolId !== null);
        if (foundSchoolId) {
          that.teacherCascaderValue = [foundSchoolId, teacherId];
        }
      });
    },
    close() {
      let that = this;
      that.show_shardow = false;
      that.show_delete = false;
      that.teacherCascaderValue = [];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      let that = this;
      that.pageNumber = val;
      that.ajaxload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../userManagement/userManagement.css");

.Add_btn {
  margin-top: 20rem;
}

.show_detail {
  height: 304rem;
}

>>>.el-button {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/accountManagement/accountManagement.vue